import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AnexoBolseiroService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all AnexoBolseiro
  list(params?: any): Observable<any[]> {
    return this.apiService
      .get<{ data: any[] }>(
        `${this.path}/getAllAnexoBolseiro`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params
      )
      .pipe(map((response) => response.data));
  }

  // Create new AnexoBolseiro
  public store(form: any): Observable<any> {
    const anexoBolseiro = form;
    return this.apiService
      .post<{ object: any }>(`${this.path}/AddAnexoBolseiro`, anexoBolseiro)
      .pipe(map((response) => response.object));
  }

  // Update existing AnexoBolseiro
  public update(form: FormGroup, id: string): Observable<any> {
    const anexoBolseiro = form.value;
    return this.apiService
      .put<{ object: any }>(`${this.path}/UpdateAnexoBolseiro/${id}`, anexoBolseiro)
      .pipe(map((response) => response.object));
  }

  // Delete existing AnexoBolseiro
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteAnexoBolseiroById/${id}`);
  }

  // Get AnexoBolseiro by ID
  public show(id: string): Observable<any> {
    return this.apiService
      .get<{ object: any }>(`${this.path}/getAnexoBolseiroById/${id}`)
      .pipe(map((response) => response.object));
  }
}
